import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
interface IProps {
  onClickExportButton: () => Promise<void>;
}

export const ExportProjectStatsButton = observer(({ onClickExportButton }: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <Button
      className='export-project-stats-button'
      onClick={() => {
        void onClickExportButton();
      }}
      startDecorator={<FontAwesomeIcon icon={faDownload} />}
    >
      {t('projects.details.stats.export')}
    </Button>
  );
});
